import React, { useState, useContext } from "react";

import ActionTypes from "./action-types";
import Context from "./reducer";
import URLS from "./urls";
import { useFetch } from "./hooks";

const PersonSelectField = ({
  people,
  required = false,
  group = "members",
  name = "person_id",
  errors,
  defaultValue = null,
  unselectPersonCallback = () => { },
  label = true,
  inputStyle = {},
  inputPlaceholder = "",
  selectPersonCallback = () => { },
  disabled = false
}) => {
  const [person, setPerson] = useState(defaultValue);
  const dispatch = useContext(Context);
  const { doFetch } = useFetch(dispatch);
  const handleSearch = (e) => {
    e.preventDefault();
    doFetch({
      urlString: URLS.PEOPLE,
      actionType: ActionTypes.SEARCH_PEOPLE,
      params: { query: e.target.value, group: group }
    });
  };
  const handleSelectPerson = (e, p) => {
    e.preventDefault();
    setPerson(p);
    dispatch({ type: ActionTypes.SELECT_PERSON, person: p });
    selectPersonCallback(p);
  };
  const handleUnselectPerson = (e) => {
    e.preventDefault();
    setPerson(null);
    dispatch({ type: ActionTypes.UNSELECT_PERSON });
    unselectPersonCallback();
  };
  if (people) {
    return (
      <label>
        {label && <span>Person:</span>}
        {errors && name in errors && (
          <div style={{ textAlign: "left", fontSize: ".75em", color: "red" }}>{errors[name]}</div>
        )}
        {person && (
          <div style={{ position: "relative" }}>
            <input type="hidden" name={name} disabled="disabled" defaultValue={person.person_id} />
            <input
              type="text"
              disabled="disabled"
              defaultValue={`${person.full_name} (#${person.agilysys_id})`}
              style={inputStyle}
            />
            <button
              style={{ position: "absolute", top: 6, right: 10 }}
              onClick={handleUnselectPerson}
            >
              X
            </button>
          </div>
        )}
        {!person && (
          <input
            type="text"
            name={name}
            onChange={handleSearch}
            autoComplete="off"
            required={required}
            style={inputStyle}
            placeholder={inputPlaceholder}
            disabled={disabled}
          />
        )}
        <div
          style={{
            zIndex: 999,
            position: "absolute",
            background: "rgb(251, 246, 242)",
            width: "100%",
            boxShadow: "5px 5px 5px 0px rgba(0, 0, 0, 0.25)"
          }}
        >
          {people.results &&
            people.results.map((n, idx) => (
              <div key={idx}>
                <img src={n.image} alt={n.full_name} style={{ width: 25, height: 25 }} />{" "}
                <button onClick={(e) => handleSelectPerson(e, n)}>
                  {n.full_name} {n.status} (#{n.agilysys_id})
                </button>
              </div>
            ))}
        </div>
      </label>
    );
  }
  return <></>;
};

export default PersonSelectField;
